import { renderFormatMessage, useFormatMessage } from '../../helpers/intl'

export const useListingPosTerminalTranslation = () => {

  const posTerminalText = renderFormatMessage('dashboard.text.posTerminal', 'POS Terminal')
  const terminalText = renderFormatMessage('dashboard.text.posTerminal', 'Terminal:')

  const posNoneTerminalText = renderFormatMessage('dashboard.text.posTerminal.none', 'None')
  const posNayaxTerminalText = renderFormatMessage('dashboard.text.posTerminal.nayax', 'Nayax')
  const posPayterTerminalText = renderFormatMessage('dashboard.text.posTerminal.payter', 'Payter')
  const posVourityTerminalText = renderFormatMessage('dashboard.text.posTerminal.vourity', 'Vourity')
  const nayaxLableText = renderFormatMessage('dashboard.text.posTerminal.nayax.label', 'Nayax Serial Number')
  const nayaxPlaceholderText = useFormatMessage(
    'dashboard.text.posTerminal.nayax.placeholder',
    'Example: 4434330823183186',
  )
  const nayaxValidationText = renderFormatMessage('dashboard.text.posTerminal.nayax.validationMessage', 'Please enter the Nayax serial number')
  const payterLableText = renderFormatMessage('dashboard.text.posTerminal.payter.label', 'Payter Serial Number')
  const payterValidationText = renderFormatMessage('dashboard.text.posTerminal.payter.validationMessage', 'Please enter the Payter serial number')
  const payterPlaceholderText = useFormatMessage(
    'dashboard.text.posTerminal.payter.placeholder',
    'Example: APM20224205211',
  )
  const posNayaxUnoMiniTerminalText = renderFormatMessage('dashboard.text.posTerminal.unomini', 'Nayax Uno Mini')
  const nayaxUnoMiniLableText = renderFormatMessage('dashboard.text.posTerminal.unomini.label', 'Nayax Uno Mini Serial Number')
  const nayaxUnoMiniValidationText = renderFormatMessage('dashboard.text.posTerminal.unomini.validationMessage', 'Please enter the Nayax Uno Mini serial number')
  const nayaxUnoMiniPlaceholderText = useFormatMessage(
    'dashboard.text.posTerminal.unomini.placeholder',
    'Enter Nayax Uno Mini Serial Number',
  )
  return {
    terminalText,
    posTerminalText,
    posNoneTerminalText,
    posNayaxTerminalText,
    posPayterTerminalText,
    posVourityTerminalText,
    nayaxLableText,
    nayaxValidationText,
    nayaxPlaceholderText,
    payterLableText,
    payterValidationText,
    payterPlaceholderText,
    nayaxUnoMiniPlaceholderText,
    nayaxUnoMiniLableText,
    posNayaxUnoMiniTerminalText,
    nayaxUnoMiniValidationText
  }
}
